Vendd.Scripts.load(function () {
    var $wrapper = $('.countdown-widget');

    if ($wrapper.length < 1)
        return;

    $('#countdown', $wrapper).countdown($('#countdown-configuration', $wrapper).data('target'), function (event) {
        $(this).html(event.strftime($('#countdown-configuration', $wrapper).data('structure')));
    });

});

